<app-standard-table class="flex-1 flex flex-col min-h-0" [title]="'admin.orderList'" [columns]="columnList"
  [data]="tableDataFilters" [totalItems]="totalItems" [pageSize]="pageSize" [isLoading]="isLoading"
  [currentPage]="currentPage" (searchChange)="search($event)" (sortChange)="onSort($event)"
  (pageChange)="onPageChange($event)" (rowClick)="onClickRow($event)" [isCreate]="false" (edit)="onEdit($event)"
  [isEditOnly]="true" [showStatusFilter]="true" [showDateRangeFilter]="true"
  (statusFilterChange)="onStatusChange($event)" (dateRangeChange)="onDateRangeChange($event)"></app-standard-table>


<div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ 'modal.editOrder' | translate }}</h3>
      <button class="close-icon" (click)="closeModal()">&times;</button>
    </div>

    <form (ngSubmit)="submit()" #orderForm="ngForm">
      <div class="form-body">
        <label for="status">{{ 'modal.status' | translate }}</label>
        <select id="status" name="status" [(ngModel)]="newOrder.status" class="form-input">
          <option value="01">{{ 'table.statusOpen' | translate }}</option>
          <option value="02">{{ 'table.statusConfirmed' | translate }}</option>
          <option value="03">{{ 'table.statusFailed' | translate }}</option>
        </select>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn-cancel" (click)="closeModal()" [disabled]="isSaving">{{ 'admin.cancel' | translate }}</button>
        <button type="submit" class="btn-create" [disabled]="!orderForm.form.valid || isSaving">
          <span *ngIf="!isSaving">{{ 'modal.updateOrder' | translate }}</span>
          <span *ngIf="isSaving">{{ 'modal.saving' | translate }}</span>
        </button>
      </div>
    </form>
  </div>
</div>